import banner from '../../../assets/industries/edu.webp'

import tick from '../../../assets/industries/tick.webp'


export const bannerData = {
    title1: 'Educational Software',
    title2: 'Development Services',
    desc: 'CodeZone provides custom software development services to healthcare companies for improving healthcare services.',
    img: banner,
    btnTitle: 'Hire Software Developers'
}

export const hireData = {
    img: tick,
    title: 'Outsource eLearning software',
    points: [
      'Competence in custom on demand app development services',
      'Flexible engagement models',
      'UI/UX optimized development',
      'Instant chat support',
      'Diverse technology stack',
      'Data privacy protection'

    ]
}

export const webDesignData = {
    title1: 'Educational Software Solutions',
    title2: 'Relevant to Your Business.',
    cards: [
        {
            title: 'Learning Management System',
            desc: 'Seamlessly integrate educational and training modules with custom LMS app development. Codezone’s educational software development services help you build feature-rich and interactive custom learning management systems (LMS).',
        },
        {
            title: 'Virtual Reality Educational Solution',
            desc: 'Provide interactive learning experience to the students with playful virtual reality solutions. Codezone’s expert software developers help your organization to develop customized eLearning app solution.',
        },
        {
            title: 'Educational Platform Development',
            desc: 'Become a trusted provider of up to date knowledge and new skills by empowering your business with educational platform & online courses like Coursera and Udemy. Hire expert software developers to build interactive and unique educational platform.',
        },
 
    ]
}